<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Nueva Consulta</v-toolbar-title>
    </v-toolbar>
    <div class="loading spacing-top" v-if="loading"></div>
    <div v-else class="spacing-top">
      <v-card>
        <v-card-text>
          <form>
            <v-text-field v-model="title" :error-messages="titleErrors" label="Asunto"
                          required @input="$v.title.$touch()"></v-text-field>
            <v-select v-model="departamento"
                      :items="items"
                      item-text="nombre"
                      item-value="id"
                      :error-messages="departamentoErrors"
                      label="Departamento" required @change="$v.departamento.$touch()"
                      no-data-text="No hay datos disponibles"></v-select>
            <div class="d-flex">
              <v-checkbox v-model="isMatch" @change="fetchTorneos" label="Pertenece a un partido"></v-checkbox>
              <v-select v-if="isMatch" class="ma-2 pa-2"
                      v-model="torneo"
                      :items="torneos"
                      item-text="description"
                      item-value="id"
                      :error-messages="torneoErrors"
                      label="Torneo" @change="fetchFechas"
                      no-data-text="No hay datos disponibles"></v-select>
              <v-select v-if="isMatch" class="ma-2 pa-2"
                       v-model="fecha"
                      :items="fechas"
                      item-text="nombreCompleto"
                      item-value="id"
                      :error-messages="fechaErrors"
                      label="Fecha" @change="fetchPartidos"
                      no-data-text="No hay datos disponibles"></v-select>
              <v-select v-if="isMatch" class="ma-2 pa-2"
                       v-model="partido"
                      :items="partidos"
                      item-text="description"
                      item-value="id"
                      :error-messages="partidoErrors"
                      label="Partido" @change="$v.departamento.$touch()"
                      no-data-text="No hay datos disponibles"></v-select>
            </div>
            <hr>
            <v-textarea v-model="cuerpo"
                        :error-messages="cuerpoErrors"
                        label="Detalle"
                        required @input="$v.cuerpo.$touch()"></v-textarea>
            <AttachFile ref="fileInput" @upload="uploadFiles"></AttachFile>
            <v-btn @click="openFileDirectory" color="primary" :disabled="saving">Agregar Adjuntos</v-btn>
            <v-btn @click="uploadAllFiles" color="primary" :disabled="saving">Crear</v-btn>
          </form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import AttachFile from '../../../common/ui/AttachFile'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'

export default {
  mixins: [validationMixin, s3UploadMixin],

  validations: {
    title: { required },
    departamento: { required },
    cuerpo: { required },
    torneo: { required: requiredIf((torneoModel) => torneoModel.isMatch) },
    fecha: { required: requiredIf((fechaModel) => fechaModel.isMatch) },
    partido: { required: requiredIf((partidoModel) => partidoModel.isMatch) }
  },

  components: {
    AttachFile
  },

  data: () => ({
    loading: false,
    saving: false,
    title: '',
    departamento: null,
    cuerpo: '',
    items: [],
    files: [],
    file: null,
    isMatch: false,
    torneos: [],
    fechas: [],
    partidos: [],
    torneo: null,
    fecha: null,
    partido: null
  }),

  computed: {
    titleErrors () {
      const errors = []
      if (!this.$v.title.$dirty) return errors
      !this.$v.title.required && errors.push('El título es requerido.')
      return errors
    },
    departamentoErrors () {
      const errors = []
      if (!this.$v.departamento.$dirty) return errors
      !this.$v.departamento.required && errors.push('El departamento es requerido.')
      return errors
    },
    cuerpoErrors () {
      const errors = []
      if (!this.$v.cuerpo.$dirty) return errors
      !this.$v.cuerpo.required && errors.push('El cuerpo es requerido.')
      return errors
    },
    torneoErrors () {
      const errors = []
      if (this.isMatch && !this.$v.torneo.$dirty) return errors
      !this.$v.torneo.required && errors.push('El torneo es requerido.')
      return errors
    },
    fechaErrors () {
      const errors = []
      if (this.isMatch && !this.$v.fecha.$dirty) return errors
      !this.$v.fecha.required && errors.push('La fecha es requerida.')
      return errors
    },
    partidoErrors () {
      const errors = []
      if (this.isMatch && !this.$v.partido.$dirty) return errors
      !this.$v.partido.required && errors.push('El partido es requerido.')
      return errors
    },
    isConsultaPartido () {
      return this.isMatch
    }
  },

  methods: {
    fetchData () {
      this.axios
        .get('departamento')
        .then(response => {
          this.items = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saving = true
        let payload = {
          title: this.title,
          departamento: this.departamento,
          cuerpo: this.cuerpo
        }
        let createConsultaPath = this.isMatch ? 'consulta-partido/new' : '/consulta/new'
        if (this.isMatch) {
          payload.partido = this.partido
        }
        this.axios
          .post(createConsultaPath, payload)
          .then((response) => {
            if (this.assets.length > 0) {
              this.axios
                .put('/mensaje/upload-s3/' + response.data.mensaje.id, { assets: this.assets })
                .catch(error => { this.$store.commit('setErrorMsg', error) })
            }
            this.$router.push({ name: 'consultas' })
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    fetchTorneos () {
      this.axios
        .get('informe-auditoria/torneos?active=true')
        .then(response => {
          this.torneos = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchFechas () {
      this.axios
        .get(`informe-auditoria/fechas?torneo=${this.torneo}&order=desc`)
        .then(response => {
          this.fechas = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchPartidos () {
      this.axios
        .get(`informe-auditoria/partidos?torneo=${this.torneo}&fecha=${this.fecha}&fromConsultas=true`)
        .then(response => {
          this.partidos = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    }
  },
  created () {
    this.loading = true
    this.fetchData()
  }
}
</script>

<style scoped>
  .spacing-top {
    margin-top: 6em !important;
  }

  .toolbar-element {
    background: linear-gradient(#e2e2e2, #cbd1db);
  }

  .toolbar-title {
    font-size: 2.2em;
    font-family: SourceSansProLight, sans-serif;
    color: #293968;
  }
</style>
